// One card for the whole campaign — every URL shares these words.
export default {
  // TODO(copy): awaiting the SEO-optimised title from jhanvi. Brief asks for 50
  // characters; Google cuts around 60 in practice, so either target is safe.
  title: {
    id: 'rm_mine-my-phone-seo_title',
    defaultMessage: 'Back Market — Mine My Phone',
  },
  // TODO(copy): awaiting the SEO-optimised description from jhanvi. Brief asks
  // for 150 characters; anything past ~155 is cut by Google and by chat unfurlers.
  description: {
    id: 'rm_mine-my-phone-seo_description',
    defaultMessage:
      'Explore the environmental, human and geopolitical impact of your phone — from the mines the raw materials come out of to the pocket it ends up in.',
  },
  imageAlt: {
    id: 'rm_mine-my-phone-seo_image_alt',
    defaultMessage: 'Mine My Phone — a Back Market campaign',
  },
} as const
